/**
 * Extract
 * @param fileName The text from which to extract the extension
 * @param includeDot whether the return value should include the dot. Default is `false`
 * @returns File extension if found, undefined if unavailable to extract for any reason
 */
export function getFileExtensionLowercased(
    fileName: string | undefined,
    includeDot?: boolean,
): string | undefined {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    if (!extension) {
        return undefined;
    }

    return includeDot ? `.${extension}` : extension;
}
